import React, { Component } from 'react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'draft-js/dist/Draft.css';
import './css/richtext.css';

class RichEditor extends Component {
    constructor(Props) {
        super(Props);
        this.handleKeyCommand = this.handleKeyCommand.bind(this);
    }

    handleKeyCommand(command, editorState) {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            this.props.onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    _onBoldClick() {
        this.props.onChange(RichUtils.toggleInlineStyle(this.props.editorState, 'BOLD'));
    }

    _onItalicsClick() {
        this.props.onChange(RichUtils.toggleInlineStyle(this.props.editorState, 'ITALIC'));
    }

    _onHeaderOneClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-one'));
    }

    _onHeaderTwoClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-two'));
    }

    _onHeaderThreeClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-three'));
    }

    _onHeaderFourClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-four'));
    }

    _onHeaderFiveClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-five'));
    }

    _onHeaderSixClick() {
        this.props.onChange(RichUtils.toggleBlockType(this.props.editorState, 'header-six'));
    }

    
  render() {
    return (
      <div className="editor-body">
      <div className="editor-header">
                <a onClick={this._onBoldClick.bind(this)}>Bold</a>
                <a onClick={this._onItalicsClick.bind(this)}>Italics</a>
                <a onClick={this._onHeaderOneClick.bind(this)}>Header One</a>
                <a onClick={this._onHeaderTwoClick.bind(this)}>Header Two</a>
                <a onClick={this._onHeaderThreeClick.bind(this)}>Header Three</a>
                <a onClick={this._onHeaderFourClick.bind(this)}>Header Four</a>
                <a onClick={this._onHeaderFiveClick.bind(this)}>Header Five</a>
                <a onClick={this._onHeaderSixClick.bind(this)}>Header Six</a>
      </div>
        <div className="editor-body-edit">
                <Editor
                    editorState={this.props.editorState}
                    onChange={this.props.onChange}
                    handleKeyCommand={this.handleKeyCommand}
                    placeholder={this.props.placeholder} />
        </div>
      </div>
    )
  }
}

export default RichEditor;


// WEBPACK FOOTER //
// ./src/HomeComponents/Editor/RichEditor.js